import request from '@/request/request2.js';
var MiguBJHYApi;
(function (MiguBJHYApi) {
    MiguBJHYApi["freeOrder"] = "/mobile/active/freeOrder";
    MiguBJHYApi["queryVrbtStatus"] = "/mobile/queryVrbtStatus";
    MiguBJHYApi["audition"] = "/bjhy/audition";
    MiguBJHYApi["query"] = "/bjhy/query";
})(MiguBJHYApi || (MiguBJHYApi = {}));
// 设置彩铃
export const freeOrder = (data) => {
    return request.post(MiguBJHYApi.freeOrder, data);
};
// 查订购关系
export const queryVrbtStatus = (data) => {
    return request.post(MiguBJHYApi.queryVrbtStatus, data);
};
// 获取试听音频列表
export const audioQuery = () => {
    return request.post(MiguBJHYApi.query, {});
};
// 获取试听url
export const getAudioUrl = (data) => {
    return request.post(MiguBJHYApi.audition, data);
};
